import type * as React from "react";

/** Opted-in single-line fields advance to unfinished inputs before submitting. */
export function handleFormEnter(event: React.KeyboardEvent<HTMLFormElement>) {
  if (
    event.key !== "Enter" ||
    event.shiftKey ||
    event.ctrlKey ||
    event.altKey ||
    event.metaKey ||
    event.nativeEvent.isComposing ||
    event.nativeEvent.keyCode === 229 ||
    !(event.target instanceof HTMLInputElement) ||
    !Object.hasOwn(event.target.dataset, "enterNavigation")
  ) {
    return;
  }
  if (event.repeat) {
    event.preventDefault();
    return;
  }
  const inputs = Array.from(
    event.currentTarget.querySelectorAll<HTMLInputElement>(
      "input[data-enter-navigation]:not(:disabled):not([readonly])",
    ),
  ).filter((input) => input.getClientRects().length > 0);
  const index = inputs.indexOf(event.target);
  const ordered = [...inputs.slice(index + 1), ...inputs.slice(0, index + 1)];
  const unfinished = ordered.find((input) => !input.value.trim());
  if (unfinished) {
    event.preventDefault();
    unfinished.focus();
    return;
  }
  const invalid = inputs.find((input) => {
    const hasError = input.getAttribute("aria-invalid") === "true";
    return !input.validity.valid || hasError;
  });
  if (invalid) {
    event.preventDefault();
    invalid.focus();
    invalid.reportValidity();
  }
}
